module.exports = __webpack_public_path__ + "media/images/user_auth_bg-e2ddfa6f3ea9a51d1a2685cd4f88ba5d.svg";